import React from "react";
const CallAction = () => {
  return (
    <div className="call-to-action-wrapper call-to-action text-white-wrapper  ptb--120">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="inner text-center">
              <span style={{ fontSize: "2em" }}>זקוקים לעזרה?</span>
              <h2>העבירו אלינו את המושכות וקבלו סיוע מיידי</h2>
              <a className="rn-button-style--2" href="/contact">
                <span>יצירת קשר</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CallAction;
